import css from 'styled-jsx/css'
import { measurements, fontSizes, BREAKPOINTS } from 'theme'

export const bannerItemStyles = css`
  .banner-item {
    display: flex;
    min-height: 31rem;
    position: relative;

    border-radius: ${measurements.borderRadius};

    padding: 1rem;
    margin: 1rem;
  }

  .banner-item-cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  .banner-item-cover img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${measurements.borderRadius};
  }

  .banner-item-cover.full-size img {
    object-fit: initial;
  }

  .banner-item-content {
    z-index: 10;
    padding: 1rem;
    margin: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    text-align: center;
  }

  .content {
    font-size: ${fontSizes.h4}
  }

  @media screen and (max-width: ${BREAKPOINTS.SM}) {
    .banner-item {
      margin: 1rem 0.5rem;
    }

    .banner-item-content {
      padding: 0.5rem;
      margin: 0.5rem;
    }
  }
`

export const actionsStyles = css`
  .actions-container {
    display: flex;
    justify-content: space-evenly;
    justify-content: space-between;
    flex-direction: row-reverse;
    width: 100%;
  }

  .actions-container :global(.action-button) {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  @media screen and (max-width: ${BREAKPOINTS.SM}) {
    .actions-container {
      padding-bottom: 1.5rem;
    }
  }
`